import { render, staticRenderFns } from "./FeatureTypeLink.vue?vue&type=template&id=18192e71&scoped=true"
import script from "./FeatureTypeLink.vue?vue&type=script&lang=js"
export * from "./FeatureTypeLink.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeLink.vue?vue&type=style&index=0&id=18192e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18192e71",
  null
  
)

export default component.exports